import { axios } from "lib/axios";
import { ColleagueDetails } from "../types";

export const getColleagueDetails = (): Promise<ColleagueDetails> => {
  return axios.get("/details");
};
